//---------------------------------Generales
function anclaanimada() {
  //redirigir anclas de forma animada
  $(".scroll").on('click', function (e) {
    e.preventDefault();
    var codigo = $(this).attr("href");
    $("html,body").animate({scrollTop: $(codigo).offset().top}, 600);
  });
}

function togglemenu() {
  if ($(window).width() < 1200) {
    $('header .navbar-toggler').on('click', function () {
      $('body').toggleClass('header-active');
    });
  }
}

function ctaFixedModalMob() {
  if($(window).width() < 768 && $('.modal').find('.btn-fixed')) {
    $('.modal').on('shown.bs.modal', function () {
      $('.modal .btn-fixed').addClass('active-fixed');
    })
  }
}

function cierreModalVideo(){
  $('.modal').each(function(e, item){
    $(this).on('hide.bs.modal', function (e) {

      //video iframe
      var src= $(this).find('iframe').attr('src');
      $(this).find('iframe').attr('src', src);
    });
  });
}

//---------------------------------Slides

function sliderClientes(){
  if($(window).width() < 992) {
    sliderSquad('.sliderClientes', 'horizontal', 0, 0, false);
  }
}

function sliderClima(){
  sliderSwiperCards('.sliderClima', 'horizontal', 0, 3, false);
}

function killHash(){
  const hash = window.location.hash;
  history.scrollRestoration = 'manual';
  window.location.href = hash;
  history.pushState('', document.title, window.location.pathname);
}

//---------------------------------Template de Slides func (class del div., horiz o vert., slidesperview, slide to click slide, breackpoints)
function sliderSwiper(DivSwiper, direction, spv, space, dynaBul){
  var swiper = new Swiper(DivSwiper + '  .swiper-container', {
    direction: direction,
    slidesPerView: spv,
    spaceBetween: space,
    play: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: DivSwiper + ' .swiper-button-next',
      prevEl: DivSwiper + ' .swiper-button-prev',
    },
    grabCursor: true,
    pagination: {
      el: DivSwiper + '  .swiper-pagination',
      dynamicBullets: dynaBul,
      clickable: true
    }
  });

  if($(DivSwiper + " .swiper-slide").length == 1) {
    $(DivSwiper + " .swiper-pagination").addClass( "disabled" );
  }
}

function sliderSwiperCards(DivSwiper, direction, spv, space, dynaBul){
  var swiper = new Swiper(DivSwiper + '  .swiper-container', {
    direction: direction,
    slidesPerView: 6,
    centeredSlides: false,
    sliderPerGroup: 1,
    spaceBetween: 0,
    freeMode: false,
    loop: false,
    allowTouchMove: true,
    mousewheel: true,
    observer: true,
    observeParents: true,
    // Navigation arrows
    navigation: {
      nextEl: DivSwiper + ' .swiper-button-next',
      prevEl: DivSwiper + ' .swiper-button-prev',
    },
    grabCursor: true,
    pagination: false,
    breakpoints: {
      0: {
        slidesPerView: 'auto',
        centeredSlides: true
      },
      576: {
        slidesPerView: 'auto',
        centeredSlides: true
      },
      767: {
        slidesPerView: 3,
        sliderPerGroup: 3,
        centeredSlides: false
      },
      991:{
        slidesPerView: 4,
        sliderPerGroup: 4,
        centeredSlides: false
      },
      1200:{
        slidesPerView: 5,
        sliderPerGroup: 5
      },
      1440:{
        slidesPerView: 6,
        sliderPerGroup: 6
      }
    }
  });
}

function sliderSquad(DivSwiper, direction, spv, space, dynaBul){
  var swiper = new Swiper(DivSwiper + '  .swiper-container', {
    direction: direction,
    slidesPerView: 1,
    centeredSlides: false,
    sliderPerGroup: 1,
    spaceBetween: 0,
    freeMode: false,
    loop: false,
    allowTouchMove: true,
    mousewheel: true,
    observer: true,
    observeParents: true,
    // Navigation arrows
    navigation: false,
    grabCursor: true,
    autoplay:
      {
        delay: 4000,
      },
    pagination: {
      el: DivSwiper + ' .swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      576: {
        slidesPerView: 1,
        sliderPerGroup: 1
      },
      768: {
        slidesPerView: 2,
        sliderPerGroup: 1,
      }
    }
  });
}

function hash(){
  if(window.location.hash === "#resultados")
  {
      $('#nav-tab #nav-resultados-tab').tab('show');
  }
}


/*jQuery Global Functions*/
$(document).ready(function () {
  togglemenu();
  anclaanimada();
  //cierreModalVideo();
  sliderClima();
  sliderClientes();
  ctaFixedModalMob();
  hash();
});
